import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  Card,
  FlatActionList,
  Page,
  Stack,
  TextButton,
} from "@towersystems/roam-common-native";
import { TerminalSettingsRootParamList } from "../../../../types";
import { useTerminalModelContextProvider } from "../../../../utilities/terminal";
import { ReceiptTemplateTextButton } from "../TerminalSettingsSettingListScreen/components/ReceiptTemplateTextButton";

export type TerminalSettingsLandingScreenProps = NativeStackScreenProps<
  TerminalSettingsRootParamList,
  "TerminalSettingsLandingScreen"
>;

export const TerminalSettingsLandingScreen = ({
  navigation,
}: TerminalSettingsLandingScreenProps) => {
  const { terminal } = useTerminalModelContextProvider();
  const onConfigureReceiptTemplate = () => {
    navigation.navigate("SelectTerminalReceiptTemplateScreen");
  };

  const items = [
    {
      key: "receipt_printer",
      title: "Default Receipt Template",
      subTitle: "Configure default receipt template",
      onPress: onConfigureReceiptTemplate,
      componentRight: () => {
        return (
          <ReceiptTemplateTextButton
            onPress={onConfigureReceiptTemplate}
            receiptTemplate={terminal.defaultReceiptTemplate}
          />
        );
      },
    },

    {
      key: "payment_methods",
      title: "Available Payment Methods",
      subTitle: "Configure which payment methods are available",
      onPress: () => navigation.navigate("SelectTerminalPaymentMethodsScreen"),
    },
  ];

  return (
    <Page title="My Terminal Configuration">
      <Stack vertical>
        <Card title="Details">
          <FlatActionList
            items={[
              {
                key: "terminal_name",
                title: `Terminal Name`,
                subTitle: "Change terminal name",
                onPress: () => navigation.navigate("EditTerminalNameScreen"),
                componentRight: () => (
                  <TextButton
                    onPress={() =>
                      navigation.navigate("EditTerminalNameScreen")
                    }
                  >
                    {terminal.name}
                  </TextButton>
                ),
              },
              {
                key: "switch_terminal",
                title: `Switch Terminal`,
                isAction: true,
                onPress: () =>
                  navigation.navigate("SelectTerminalSettingScreen"),
              },
            ]}
          />
        </Card>
        <Card title="Configure">
          <FlatActionList items={items} />
        </Card>
      </Stack>
    </Page>
  );
};
